import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";

interface IProps {
    /**
     * The callback to call when the delete is successful
     */
    onDelete: () => void;
}

export const DeleteUpload = ({ onDelete }: IProps) => {
    const deleteUpload = () => {
        onDelete();
        return;
    };

    return (
        <IconButton onClick={deleteUpload} edge={"end"}>
            <Delete fontSize={"small"} />
        </IconButton>
    );
};
